import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DoughnutChart, DoughnutResultToChart } from './doughnut-chart';
import { configDoughnutChart } from './doughnut-chart.config';
import { DoughnutChartService } from './doughnut-chart.service';
import { chartDoughnutColor } from '../chart.config';
import { BaseChartDirective } from 'ng2-charts';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'cc-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent implements OnInit {
  @ViewChildren(BaseChartDirective) charts: QueryList<BaseChartDirective>;
  @Input() results = new Observable<DoughnutChart[]>();
  public config = configDoughnutChart;
  public empty = true;
  public resultToChart: DoughnutResultToChart;
  public doughnutLabels: string[];
  public chartColors = [chartDoughnutColor];
  public tempResult;

  constructor(private doughnutChartService: DoughnutChartService, private languageService: LanguageService) {}

  ngOnInit() {
    this.setChartsTranslated();
    this.languageService.onLanguageChange.subscribe(() => {
      this.setChartsTranslated();
    });
  }

  setChartsTranslated() {
    this.results.subscribe(results => {
      this.tempResult = results;
      this.checkEmptyAndPrepare(this.tempResult);
      this.doughnutChartService.translateChartLabels(this.tempResult).subscribe(labels => {
        this.doughnutLabels = labels;
        this.doughnutChartService.updateChartXLabels(this.doughnutLabels, this.charts);
      });
    });
  }

  checkEmptyAndPrepare(result): DoughnutChart[] {
    this.empty = this.doughnutChartService.checkEmpty(result);
    if (this.empty) {
      const tempResult: DoughnutChart[] = this.doughnutChartService.prepareChartOnEmptyData();
      this.resultToChart = this.doughnutChartService.prepareChart(tempResult);
      return tempResult;
    } else {
      this.resultToChart = this.doughnutChartService.prepareChart(result);
      return result;
    }
  }
}
